import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../services/store/userSlice";
import { allocationService, timesheetApi } from "../../services";
import { Sidebar } from "primereact/sidebar";
import { ManagerAllocation } from "./manager-allocation";
import { EmployeeAllocation } from "./employee-allocation";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { APPLICATION_MANAGER, APPLICATION_EMPLOYEE } from '../../config/permissions'
import { hasPermission } from "../../components/protected/ProtectedSection";
import "./style.scss";

export const NewAllocation = ({
  teamAllocation,
  clickedUser,
  mode = "employee",
  show = false,
  setShow,
  dashboardRefresh,
  reqMgrAlloc,
}) => {
  const user = useSelector(selectUser);
  const [isEmployeeDashboard, setDashboard] = useState(false);
  const [users, setUsers] = useState([]);
  const [allocationTypes, setAllocationTypes] = useState([]);
  const [mgrDialog, setMgrDialog] = useState(false);
  const [allocationMessage, setAllocationMessage] = useState([]);
  const [userProjects, setUserProjects] = useState([]);
  let count = 0
  useEffect(() => {
    if (hasPermission(APPLICATION_EMPLOYEE)) {
      setDashboard(true)
      count++;
    }
  }, []);


  const onHide = () => {
    setMgrDialog(false);
  };

  const fetchStatus = (status) => {
    if (status === true)
      return <i className="pi pi-check-circle" style={{ fontSize: "2em" }}></i>;
    if (status === false)
      return <i className="pi pi-times-circle" style={{ fontSize: "2em" }}></i>;
  };

  const fetchStatusColor = (status) => {
    if (status === true) return "green";
    if (status === false) return "red";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span
        style={{
          color: fetchStatusColor(data.status),
          width: "40px",
        }}
      >
        {fetchStatus(data.status)}
      </span>
    );
  };

  const AllocationMsgDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog"
        header="Allocation Message"
        visible={mgrDialog}
        onHide={() => onHide()}
        style={{ width: "40vw" }}
      >
        <DataTable
          resizableColumns
          columnResizeMode="fit"
          // showGridlines
          responsiveLayout="scroll"
          scrollable="horizontal"
          value={allocationMessage}
        // stripedRows
        >
          <Column
            field="username"
            header="Name"
            sortable
            headerStyle={{ width: "12rem" }}
          ></Column>
          <Column
            field="message"
            header="Message"
            sortable
            headerStyle={{ width: "12rem" }}
          ></Column>
          <Column
            field="status"
            header="Status"
            body={statusBodyTemplate}
            sortable
            headerStyle={{ width: "8rem" }}
          ></Column>
        </DataTable>
      </Dialog>
    );
  };

  const responseAllocData = (resAllocatedData) => {
    setAllocationMessage(resAllocatedData);
  };

  return (
    <div>
      {mgrDialog ? (
        <div>{AllocationMsgDialog()}</div>
      ) : (
        <Sidebar
          className="p-sidebar-md"
          position="right"
          visible={show}
          onHide={() => setShow(false)}
        >
          <h1 className="p-2">New Allocation</h1>
          <div className="">
            {isEmployeeDashboard ? (
              <EmployeeAllocation
                projects={userProjects}
                allocationTypes={allocationTypes}
                setShow={setShow}
                dashboardRefresh={dashboardRefresh}
              />
            ) : reqMgrAlloc ? (
              <ManagerAllocation
                clickedTeamUser={clickedUser}
                users={users}
                allocationTypes={allocationTypes}
                setShow={setShow}
                setMgrDialog={setMgrDialog}
                responseData={(resAllocatedData) =>
                  responseAllocData(resAllocatedData)
                }
              />
            ) : (
              <EmployeeAllocation
                projects={userProjects}
                users={users}
                allocationTypes={allocationTypes}
                setShow={setShow}
                dashboardRefresh={dashboardRefresh}
              />
            )}
          </div>
        </Sidebar>
      )}
    </div>
  );
};
